/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PartnerLifeTimeState {
    PendingApproval = 0,
    WaitingForApproval = 1,
    Mutual = 2,
    PartnerRemoved = 3,
}
